/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible component output types.
 * @export
 */
export type ComponentOutputType = ComponentOutputTypeHtml | ComponentOutputTypeJson;

/**
 * The html output type.
 * @export
 */
export type ComponentOutputTypeHtml = typeof COMPONENT_OUTPUT_TYPE_HTML;

/**
 * The json output type.
 * @export
 */
export type ComponentOutputTypeJson = typeof COMPONENT_OUTPUT_TYPE_JSON;

/**
 * The html output constant.
 * @export
 */
export const COMPONENT_OUTPUT_TYPE_HTML = 'html';

/**
 * The json output constant.
 * @export
 */
export const COMPONENT_OUTPUT_TYPE_JSON = 'json';
